import Vue, { VNode } from 'vue';
import { Component } from 'vue-property-decorator';

require('./Separator.scss');

@Component({ name: 'Separator' })
export class Separator extends Vue {
  render(): VNode {
    return <div class="lp-separator" />;
  }
}
